import React, { useState, useEffect } from 'react';
import {
  Button,
  Col,
  Grid,
  Input,
  InputPicker,
  Nav,
  Pagination,
  Row,
  Tooltip,
  Whisper,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  IconButton,
  FlexboxGrid,
  InputGroup,
  Form,
  useToaster,
  Message,
  Table,
  InputNumber,
  SelectPicker,
  Toggle,
  toaster
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import useTableHeight from '@/components/useTableHeight';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import { Popconfirm } from 'antd';
import { ReviewPass, UserChange } from '@rsuite/icons';

const ProductTypeMaster = ({
  label,
  productType,
  categorydatar,
  discate,
  fetchDatar,
  data,
  submit2,
  searchQuery2,
  filterDataOfPrdt,
  isLoading2,
  editedRowIdsProduct,
  editedDataProduct,
  selectedCategoryCode,
  setSelectedCategoryCode,
  selectedBuyerp,
  setEditedRowIdsProduct,
  //handle function
  handleEditRowProduct,
  handleStatusCptye,
  handleStatusDptye,
  handleInputChange2,
  handleInputChangeProduct,
  handleSaveRowProduct,
  handleBuyerChangep,
  handleSearch2,
  editedRowIdProduct,
  handleCancelPtech,
  processInputRef
}) => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();

  return (
    <>
      <FlexboxGrid justify="space-between" style={{ marginBottom: '10px' }} align="bottom">
        <FlexboxGrid.Item as={Col} colspan={24} md={6}>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>{label[0]?.attributes.Category}</b>
            </Form.ControlLabel>
            <InputPicker
              data={categorydatar}
              placeholder="Select"
              value={selectedCategoryCode}
              labelKey="label"
              valueKey="value"

              placement="autoVerticalStart"
              onChange={value => {
                setSelectedCategoryCode(value);
              }}
              block
              onOpen={fetchDatar}
              menuStyle={{ width: 180 }}
            />
          </Stack>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} md={10}>
          <Form.ControlLabel>
            <b>{label[0]?.attributes.ProductType}</b>
          </Form.ControlLabel>
          <Stack spacing={10}>
            <Input
              id="ProductTypeName"
              name="ProductTypeName"
              autoComplete="off"
              ref={processInputRef}
              value={productType && productType.ProductTypeName ? productType.ProductTypeName : ''}
              onChange={value => handleInputChange2('ProductTypeName', value)}
              onPressEnter={submit2}
            />
            {editedRowIdProduct ? (
              <Button appearance="primary" color="cyan" onClick={handleSaveRowProduct}>
                {' '}
                Update
              </Button>
            ) : (
              <Button appearance="primary" color="cyan" onClick={submit2}>
                {' '}
                Add
              </Button>
            )}
          </Stack>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} md={8}>
          <Stack className="mstr-search1" spacing={5}>
            <SelectPicker
              data={data}
              placeholder="Status"
              labelKey="label"
              value={selectedBuyerp}
              onChange={handleBuyerChangep}
              searchable={false}
              valueKey="value"
              size="md"
              appearance="default"
              style={{ width: 130 }}
              cleanable={false}
            />
            <InputGroup inside>
              <Input
                placeholder="Search"
                type="text"
                value={searchQuery2}
                onChange={handleSearch2}
              />
              <InputGroup.Addon>
                <SearchIcon />
              </InputGroup.Addon>
            </InputGroup>
          </Stack>
        </FlexboxGrid.Item>
      </FlexboxGrid>

      <Table
        rowHeight={60}
        data={filterDataOfPrdt}
        height={tableHeight}
        rowKey="id"
        bordered
        cellBordered
        loading={isLoading2}
      >
        <Table.Column width={60} fixed>
          <Table.HeaderCell>
            <b>Sr.No.</b>
          </Table.HeaderCell>
          <Cell>{(_, rowIndex) => +rowIndex + 1}</Cell>
        </Table.Column>
        <Table.Column width={200} flexGrow={1}>
          <Table.HeaderCell>
            <b>{label[0]?.attributes.Category}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData =>
                // editedRowIdsProduct.includes(rowData.id) ? (
                //   <InputPicker
                //     data={categorydatar}
                //     placeholder="Select"
                //     labelKey="label"
                //     valueKey="value"
                //     placement="auto"
                //     menuStyle={{ maxWidth: 250 }}
                //     value={
                //       editedDataProduct[rowData.id]?.CategoryCode || rowData.attributes.Categorycode
                //     }
                //     onChange={value => handleInputChangeProduct(rowData.id, 'CategoryCode', value)}
                //     onOpen={fetchDatar}
                //   />
                // ) : (
                // categorydatar.find(
                //   category => category.value === rowData.attributes.Categorycode
                // )?.label || ''

                discate.find(category => category.value === rowData.attributes.Categorycode)
                  ?.label || ''
              // )
            }
          </Table.Cell>
        </Table.Column>

        <Table.Column width={170} flexGrow={1}>
          <Table.HeaderCell>
            <b>{label[0]?.attributes.ProductType}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData => (
                // editedRowIdsProduct.includes(rowData.id) ? (
                //   <Input
                //     value={editedDataProduct[rowData.id]?.ProductTypeName || ''}
                //     onChange={value => handleInputChangeProduct(rowData.id, 'ProductTypeName', value)}
                //   />
                // ) : (
                <span>{rowData.attributes.ProductTypeName}</span>
              )
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={90} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIdsProduct.includes(rowData.id) ? (
                <div>
                  {/* <IconButton
                    size="sm"
                    icon={<CheckIcon />}
                    active
                    onClick={() => handleSaveRowProduct(rowData.id)}
                    style={{ marginRight: '10px' }}
                    disabled={
                      !editedDataProduct[rowData.id]?.ProductTypeName ||
                      editedDataProduct[rowData.id]?.ProductTypeName.trim() === '' ||
                      editedDataProduct[rowData.id]?.ProductTypeName.startsWith(' ') ||
                      editedDataProduct[rowData.id]?.ProductTypeName.endsWith(' ')
                    }
                  /> */}
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowProduct(rowData)}
                    style={{ marginRight: '10px' }}
                  />
                  <IconButton size="sm" icon={<CloseIcon />} active onClick={handleCancelPtech} />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowProduct(rowData)}
                  />
                  {rowData.attributes.dis === 'Discontinue' ? (
                    <Popconfirm
                      title="Continue Category"
                      description="Are you sure you want to continue this Category?"
                      onConfirm={() => handleStatusCptye(rowData.id)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Continue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<CheckRoundIcon />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleStatusCptye(rowData.id)}
                        />
                      </Whisper>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Discontinue Category"
                      description="Are you sure you want to discontinue this Category?"
                      onConfirm={() => handleStatusDptye(rowData.id)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Discontinue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<ReviewPass />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handleStatusDptye(rowData.id)}
                        />
                      </Whisper>
                    </Popconfirm>
                  )}
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
      <p>
        <small>Total row:{filterDataOfPrdt.length}</small>
      </p>
    </>
  );
};

export default ProductTypeMaster;
